import { useEventListener } from '@lumapps/lumx-hooks/hooks/useEventListener';

/**
 * Hook to detect Ctrl+K / Cmd+K keyboard shortcut
 * Calls the callback when the shortcut is pressed
 *
 * @param onShortcut - Callback function to execute when Ctrl+K or Cmd+K is pressed
 */
export const useSpotlightKeyboardShortcut = (onShortcut?: () => void) => {
    useEventListener('keydown', (event: KeyboardEvent) => {
        if (onShortcut && (event.ctrlKey || event.metaKey) && event.key === 'k') {
            event.preventDefault(); // Prevent browser search
            onShortcut();
        }
    });
};
